import { useState } from "react";
import { infNFesInterface, infUnidTranspInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { getUuidV4 } from "../../../../utils/utils";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Col, Form, Table } from "react-bootstrap";
import { JConfirmDelete, JRow, MensagemModal } from "../../../../components/Components";

interface formProps {
    notaFiscal: infNFesInterface;
    setNotaFiscal: React.Dispatch<React.SetStateAction<infNFesInterface>>;
    id: number | string;
}
const initialSelectLacre: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

const NFesUnidadeTranspInfLacreCargaLacresUnidTransp: React.FC<formProps> = ({ notaFiscal, setNotaFiscal, id }) => {
    const [numeroLacre, setNumeroLacre] = useState<string>('');
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelectLacre);
    const [showModal, setShowModal] = useState<boolean>(false);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelectLacre);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const validaPreenchimento = () => {
        if (numeroLacre.trim() === "") {
            alerta('Informe o número do lacre.');
            return false;
        }

        if (notaFiscal.infUnidTransp?.filter(item =>
            item.id.toString() === id.toString())[0].lacUnidTransp?.find(l =>
                l.nLacre.toString() === numeroLacre.toString().trim())) {
            alerta('Lacre já adicionado.');
            return false;
        }

        return true;
    }
    const handleAddLacre = () => {
        if (validaPreenchimento()) {

            notaFiscal.infUnidTransp?.filter(f => f.id.toString() === id.toString())[0].lacUnidTransp?.push({
                id: getUuidV4(),
                nLacre: numeroLacre
            });
            setNumeroLacre('');
        }
    }

    const handleRemoverLacre = (idLacre: number | string) => {
        if (notaFiscal.infUnidTransp) {
            const infUnidadeTransporte = notaFiscal.infUnidTransp.filter(item =>
                item.id.toString() === id.toString())

            const index = notaFiscal.infUnidTransp.findIndex((item: infUnidTranspInterface) =>
                item.id.toString() === id.toString())

            if (index !== -1) {
                let newLista = notaFiscal.infUnidTransp[index].lacUnidTransp?.filter(item =>
                    item.id.toString() !== idLacre.toString()) || [];

                setNotaFiscal({
                    ...notaFiscal,
                    infUnidTransp: [
                        ...notaFiscal.infUnidTransp.filter(item => item.id.toString() !== id.toString()),
                        {
                            id: infUnidadeTransporte[0].id,
                            idunidtransp: infUnidadeTransporte[0].idunidtransp,
                            qtdrat: infUnidadeTransporte[0].qtdrat,
                            tpunidtransp: infUnidadeTransporte[0].tpunidtransp,
                            lacUnidTransp: newLista
                        }
                    ]
                })
            }
        }
        setShowModal(false);
    }
    return (<>

        <JRow className="mb-3">
            <Col md={6}>
                <Form.Group>
                    <Form.Label>Número do lacre</Form.Label>
                    <Form.Control type="text" value={numeroLacre}
                        placeholder="Digite o número + [Enter] para adicionar"
                        onChange={(e) => setNumeroLacre(e.target.value)}
                        onKeyUp={(e) => {
                            if (e.key === 'Enter') {
                                handleAddLacre();
                            }
                        }}
                    />
                </Form.Group>
            </Col>
        </JRow>

        <Table striped bordered hover size="sm" responsive>
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '4.5rem' }}>#</th>
                    <th>Número do lacre</th>
                </tr>
            </thead>
            <tbody>
                {notaFiscal.infUnidTransp?.filter(f => f.id.toString() === id.toString()).flatMap(m =>
                    m.lacUnidTransp).map(item => {
                        return (
                            <tr key={item?.id}>
                                <td className="text-center">
                                    <Link to={''} className="text-danger">
                                        <FontAwesomeIcon icon={faTrash} onClick={() =>
                                            item?.id && handleOpenModal(
                                                {
                                                    id: item.id,
                                                    title: item?.nLacre
                                                }
                                            )} />
                                    </Link>
                                </td>
                                <td>
                                    {item?.nLacre}
                                </td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </Table>

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemoverLacre}
            selectedObject={selected.title}
            id={selected.id}
        />
    </>)
}
export default NFesUnidadeTranspInfLacreCargaLacresUnidTransp;